import { faCheck as fasCheck, faXmark as fasXmark } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { faSpinnerThird as fadSpinnerThird } from "@awesome.me/kit-3777c2145e/icons/duotone/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ReactNode } from "react";
import React from "react";
import type { ButtonProps } from "./Button";
import { Button } from "./Button";

export type ProgressButtonState = "" | "loading" | "error" | "done";

interface StateProps {
	children?: ReactNode;
	icon?: ReactNode;
}

export interface ProgressButtonProps extends ButtonProps {
	state?: ProgressButtonState;
	/**
	 * @deprecated
	 */
	loadingChildren?: ReactNode;
	/**
	 * @deprecated
	 */
	doneChildren?: ReactNode;
	/**
	 * @deprecated
	 */
	errorChildren?: ReactNode;

	loadingProps?: StateProps;
	doneProps?: StateProps;
	errorProps?: StateProps;
}

export const ProgressButton = React.forwardRef<HTMLElement, ProgressButtonProps>(
	(
		{
			children,
			className,
			disabled,
			icon,
			doneChildren,
			errorChildren,
			loadingChildren,
			doneProps = { children: doneChildren },
			errorProps = { children: errorChildren },
			loadingProps = { children: loadingChildren },
			state,
			variant = "primary",
			...props
		},
		ref,
	) => {
		let finalChildren = children;
		let finalClassName = className;
		let finalDisabled = disabled;
		let finalFaIcon = icon;
		let finalVariant = variant;

		switch (state) {
			case "loading":
				finalChildren = loadingProps.children || "Folyamatban...";
				finalClassName += " btn-progress";
				finalDisabled = true;
				finalFaIcon = loadingProps.icon || <FontAwesomeIcon icon={fadSpinnerThird} spin />;
				break;
			case "done":
				finalChildren = doneProps.children || "Kész";
				finalDisabled = true;
				finalFaIcon = doneProps.icon || <FontAwesomeIcon icon={fasCheck} />;
				finalVariant = variant.includes("outline") ? "outline-success" : "success";
				break;
			case "error":
				finalChildren = errorProps.children || "Hiba";
				finalDisabled = true;
				finalFaIcon = errorProps.icon || <FontAwesomeIcon icon={fasXmark} />;
				finalVariant = variant.includes("outline") ? "outline-danger" : "danger";
				break;
			default:
		}

		return (
			<Button
				ref={ref}
				className={finalClassName}
				variant={finalVariant}
				icon={finalFaIcon}
				disabled={finalDisabled}
				{...props}
			>
				{props.rounded ? null : finalChildren}
			</Button>
		);
	},
);
